const qna = [
  {
    name: "Q1",
    question: "Hello ma'am, for the data collection task this week, are we allowed to use a Python script to programmatically generate our raw network logs directly into the data folder to simulate live system traffic, or should we rely on an external pre-existing dataset file?",
    answer: "Yes you are allowed to use scripts or any tools"
  },
  {
    name: "Q2",
    question: "I would like to do my internship project individually, as I believe it will help me learn and understand the project better. However, I am unable to find the option to select an individual group on the portal. Could you please let me know if it is possible to register individually or guide me on how to proceed?",
    answer: "Yes: you can do your project individually. "
  },
  {
    name: "Q3",
    question: "Over the past two weeks I have completed the following. Week 1 — Data Collection and Cleaning, Week 2 — Backend and Frontend,  Please let me know if anything needs to be corrected or adjusted.",
    answer: "We will be reviewing the Project work in Github and will get back to you"
  }

];

export default qna;